import React from 'react';
import SampleComponent from './sample1'; // sample1.jsxをインポート

function App() {
  const viewText = 'Reactのサンプルページ'; // 変数を定義

  return (
    <div>
      <SampleComponent text={viewText} /> {/* 変数をpropsとして渡す */}
    </div>
  );
}

export default App;